module.exports = __webpack_public_path__ + "static/logo-9dbd5305a0c9f1f8575972ed22a622a6.png";